import { render } from "./NewsRoom.vue?vue&type=template&id=6c227916&ts=true"
import script from "./NewsRoom.vue?vue&type=script&lang=ts"
export * from "./NewsRoom.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__